<div class="form-container">
    <h2>Crear Usuario</h2>
    <form [formGroup]="usuarioForm" (ngSubmit)="onSubmit()">
        <!-- Campo Nombre -->
        <div class="form-group">
          <label for="Email">Correo</label>
          <input
            id="Email"
            type="text"
            formControlName="Email"
            placeholder="Ingrese el correo electrónico del usuario"
          />
          <small *ngIf="controls['Email'].invalid && controls['Nombre'].touched" class="error">
            El correo electrónico es obligatorio.
          </small>
        </div>
    
        <!-- Campo Descripción -->
        <div class="form-group">
          <label for="Nombre">Nombre completo</label>
          <input
            id="Nombre"
            formControlName="Nombre"
            placeholder="Ingrese el nombre"
          />
          <small *ngIf="controls['Nombre'].invalid && controls['Descripcion'].touched" class="error">
            El nombre es obligatorio.
          </small>
        </div>
    
      <!-- Campo Activa -->
      <div class="form-group">
      <label for="Activa">Crear registros</label>
      <input
          id="Crear"
          type="checkbox"
          formControlName="Crear"
      />
      </div>
  
      <!-- Campo Activa -->
      <div class="form-group">
          <label for="Activa">Eliminar registros</label>
          <input
              id="Eliminar"
              type="checkbox"
              formControlName="Eliminar"
      />
      </div>
  
      <!-- Campo Activa -->
      <div class="form-group">
          <label for="Activa">Editar registros</label>
          <input
              id="Editar"
              type="checkbox"
              formControlName="Editar"
      />
      </div>
  
      <!-- Campo Activa -->
      <div class="form-group">
          <label for="Activa">Ver registros</label>
          <input
              id="Ver"
              type="checkbox"
              formControlName="Ver"
      />
      </div>
    
  
    
        <div class="form-group" style="display: flex; gap: 10px;">
          <button type="submit" [disabled]="usuarioForm.invalid">Guardar Usuario</button>
          <button type="button" (click)="cancelarcreacion()">Cancelar</button>
        </div>
      </form>
  </div>